import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { StoreBase } from "../../../stores/models/store.model";
import { CaptionService } from "../../../../utils/shared-services/caption.service";
import { StoreSelectionDialogData } from "../../models/dialog.model";
import { Tag } from "../../../tags/models/tag.model";
import { GroupItem, GroupWithItems } from "../../../store-groups/models/group-item.model";
import { StoreGroupMembersApiService } from "../../../store-groups/services/store-group-member.resource";
import { TagApiService } from "../../../tags/services/tag.resource";

@Component({
    selector: "report-category-selection",
    templateUrl: "./src/app/features/price-change/templates/dialogs/store-selection.component.html",
    standalone: false
})
export class PriceChangeStoreSelectionDialog implements OnInit {

    public captions: Record<string, string>
    public stores: StoreBase[];
    public tags: Tag[];
    public storeGroups: GroupWithItems[];
    public selectedStores: StoreBase[];
    public firstTimeGroupSelection: Boolean = true;
    public firstTimeTagSelection: Boolean = true;
    public isPriceMatch: Boolean = false;
    public storesFrom: StoreBase[];
    public storeSelectedToReverse: StoreBase;
    public selectedStoresToPM: any[];
    public selectedStoreFromPM: any;
    public hideProd: boolean = false;


    constructor(
        @Inject(StoreGroupMembersApiService) private storeGroupMembersApiService: StoreGroupMembersApiService,
        @Inject(TagApiService) private tageApiService: TagApiService,
        @Inject(CaptionService) private captionService: CaptionService,
        @Inject(MatDialogRef) public dialogRef: MatDialogRef<PriceChangeStoreSelectionDialog>,
        @Inject(MAT_DIALOG_DATA) public data: StoreSelectionDialogData,
    ) {
        this.captions = this.captionService.captions;
        this.stores = [];
        this.storeGroups = [];
        this.tags = [];
        this.selectedStores = [];
        this.storesFrom = [];
        this.selectedStoresToPM = [];
        this.selectedStoreFromPM = [];

    }

    ngOnInit(): void {
        this.stores = structuredClone(this.data.stores);
        this.storesFrom = structuredClone(this.data.stores);
        this.isPriceMatch = this.data.isPriceMatch;
        this.storeGroups = structuredClone(this.data.storeGroups);
        this.tags = structuredClone(this.data.tags);
        this.selectedStoresToPM = this.data.selectedStoresToPM;
        this.selectedStoreFromPM = this.data.selectedStoreFromPM;


        // hide price match select all from PROD only
        if (
            window.location.origin.indexOf('localhost') > -1 ||
            window.location.origin.indexOf('ci') > -1 ||
            window.location.origin.indexOf('qa') > -1
        ) {
            this.hideProd = true;
        }

        if (this.selectedStoreFromPM && this.selectedStoreFromPM.length > 0) {
            this.preSelectedStores();
        }
    }

    preSelectedStores(): void {


        let selectedStoreIndex = this.stores.findIndex(s => s.id === this.selectedStoreFromPM[0].id);
        this.stores.splice(selectedStoreIndex, 1);

        const selectedIds = this.selectedStoresToPM.map((s: any) => s.id);
        selectedIds.push(this.selectedStoreFromPM[0].id);

        this.stores.forEach(store => {
            store.isChecked = selectedIds.includes(store.id);
        });

        this.storesFrom.forEach(store => {
            store.isChecked = store.id === this.selectedStoreFromPM[0].id;
        });

    }

    selectStore(store: StoreBase, reset: Boolean): void {
        if (reset) {
            this.resetGroupItemSelection();
            this.resetTagSelection();
            store.isChecked = !store.isChecked;
        } else {
            this.stores.forEach(s => {
                if (s.id == store.id) s.isChecked = true;
            });
        }
    }

    selectGroupItem(selectedItem: GroupItem): void {
        this.resetStoreSelection();
        this.resetTagSelection();
        selectedItem.isChecked = !selectedItem.isChecked;

        this.storeGroups.forEach(group => {
            group.groupItems.forEach(item => {
                if (item.isChecked) {
                    this.storeGroupMembersApiService.getGroupItemInfoById(item.id).then(stores => {
                        for (let store of stores) {
                            this.selectStore(store, false);
                        }
                    });
                }
            });
        });
    }

    addObject(array: string | any[], id: any) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].id === id) {
                return false;
            }
        }
        return true;
    }

    selectTag(selectedTag: Tag): void {
        this.resetStoreSelection();
        this.resetGroupItemSelection();
        selectedTag.isChecked = !selectedTag.isChecked;
        this.tags.forEach(tag => {
            if (tag.isChecked) {
                this.tageApiService.getStoresByTagID(tag.id).then(stores => {
                    for (let store of stores) {
                        this.selectStore(store, false);
                    }
                });
            }
        });
    }

    selectAllStores(): void {
        this.resetAllSelection();
        this.stores.forEach(store => store.isChecked = true);
    }

    selectAllGroupItems(): void {
        this.resetAllSelection();
        this.storeGroups.forEach(group => {
            group.groupItems.forEach(item => {
                item.isChecked = true;
                this.storeGroupMembersApiService.getGroupItemInfoById(item.id).then(stores => {
                    for (let store of stores) {
                        this.selectStore(store, false);
                    }
                });
            });
        });
    }
    selectAllTags(): void {
        this.resetAllSelection();
        this.tags.forEach(tag => {
            tag.isChecked = true;
            this.tageApiService.getStoresByTagID(tag.id).then(stores => {
                for (let store of stores) {
                    this.selectStore(store, false);
                }
            });
        });
    }

    resetStoreSelection(): void {
        this.stores.forEach(store => store.isChecked = false);
    }
    resetGroupItemSelection(): void {
        this.firstTimeGroupSelection = true;
        this.storeGroups.forEach(group => {
            group.groupItems.forEach(item => {
                item.isChecked = false;
            });
        });
    }
    resetTagSelection(): void {
        this.firstTimeTagSelection = true;
        this.tags.forEach(tag => tag.isChecked = false);
    }

    resetAllSelection(): void {
        this.resetStoreSelection();
        this.resetGroupItemSelection();
        this.resetTagSelection();
    }

    confirmSelection(): void {
        this.dialogRef.close({
            stores: this.stores,
            storeGroups: this.storeGroups,
            tags: this.tags,
            selectedStores: this.stores.filter(store => store.isChecked),
            selectedStoreFrom: this.storesFrom.filter(store => store.isChecked)
        })
    }

    filterStore(store: StoreBase, searchStr: string) {
        return !searchStr || store.displayName.toLowerCase().includes(searchStr);
    }

    onCheckboxChange(selectedStore: any): void {
        // Uncheck all FROM stores
        this.storesFrom.forEach(store => store.isChecked = false);
        // Check only the selected FROM store
        selectedStore.isChecked = true;
        // Rebuild TO list from all stores, excluding the currently selected FROM
        this.stores = structuredClone(this.data.stores).filter(store => store.id !== selectedStore.id);

    };
}


